import React, { FC } from "react";
import { Flex, Box } from "../../../components/Container";
import { ExportContacts, IExportContactsProps } from "./ExportContacts";
import { theme } from "@ovou-inc/ovou-ui";
import { ManageTags } from "./ManageTags";
import { useTagManagement } from "../hooks/useTagManagement";

interface ITopHeaderProps extends IExportContactsProps {
  refetchContactsData: () => void;
}

const TopHeader: FC<ITopHeaderProps> = ({
  canExport,
  filters,
  refetchContactsData,
}) => {
  const { isOpen, handleOpenManageTags, handleCloseManageTags } =
    useTagManagement({
      teamId: filters.teamId,
      refetchContactsData,
    });

  return (
    <Flex alignItems="center" style={{ gap: "16px" }}>
      <Box
        color={theme.palette.brand.primary.orange}
        fontSize={14}
        fontWeight={800}
        onClick={handleOpenManageTags}
        cursor="pointer"
        width="max-content"
      >
        Manage Tags
      </Box>
      <ExportContacts canExport={canExport} filters={filters} />
      <ManageTags
        isOpen={isOpen}
        onClose={handleCloseManageTags}
        teamId={filters.teamId}
        refetchContactsData={refetchContactsData}
      />
    </Flex>
  );
};

export default TopHeader;
